export const USER_LEGAL_AGE = 16;
